import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
// ✅ IMPORT BOTH CANCEL FUNCTIONS
import { cancelRide, cancelRideRequest } from "../utils/api"; 
import "../css/cancelride.css";

export default function CancelRide({ user }) {
  const { id } = useParams(); // This is the rideId from the URL
  const navigate = useNavigate();
  const location = useLocation(); // ✅ This catches the state we passed from RideDetailsCard
  const token = localStorage.getItem("travelo_token");

  // ✅ Extract the ride and request data passed from the previous page
  const ride = location.state?.ride || {};
  const requestId = location.state?.requestId || null;

  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  // Determine if current user is the driver
  const driverId = ride?.postedBy?._id || ride?.postedBy;
  const userId = user?._id || user?.id;
  const isDriver = userId && driverId && String(userId) === String(driverId);

  // Different reason sets for driver vs passenger
  const driverReasons = [
    "No passengers joined",
    "Vehicle issue",
    "Personal emergency",
    "Route change",
  ];
  const passengerReasons = [
    "Change of plans",
    "Personal emergency",
    "Driver delayed",
    "Found another ride",
  ];
  
  const reasons = isDriver ? driverReasons : passengerReasons;

  const handleCancel = async () => {
    if (!reason.trim()) {
      alert("Please select or enter a reason.");
      return;
    }

    try {
      setLoading(true);

      if (isDriver) {
        // 🚗 1. DRIVER CANCELLING THE ENTIRE RIDE
        await cancelRide(id, { reason }, token);
        alert(`Ride cancelled 🚫. Reason: ${reason}`);
        navigate("/profile"); 
      } else {
        // 🧍 2. PASSENGER CANCELLING THEIR SPECIFIC BOOKING
        if (!requestId) {
          alert("Error: Request ID is missing. Cannot cancel seat.");
          return;
        }
        
        // Note: Ensure your cancelRideRequest API function accepts the reason if you want to save it!
        // We pass the reason along with the token
        await cancelRideRequest(id, requestId, token, reason); 
        
        alert(`Booking cancelled 🚫. Reason: ${reason}`);
        
        // Send the passenger back to the ride details or their bookings page
        navigate(-1); 
      }
      
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to cancel. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cancel-ride-container">
      <div className="cancel-card">
        <h2>❌ Cancel {isDriver ? "Ride" : "Booking"}</h2>
        <p className="cancel-subtext">
          {isDriver
            ? "Please tell passengers why you’re cancelling this ride."
            : "Please tell the driver why you’re cancelling your request."}
        </p>

        {/* Reason Options */}
        <div className="reason-options">
          {reasons.map((r) => (
            <label key={r} className="reason-label">
              <input
                type="radio"
                name="reason"
                value={r}
                checked={reason === r}
                onChange={(e) => setReason(e.target.value)}
              />
              {r}
            </label>
          ))}
        </div>

        {/* Custom reason */}
        <textarea
          className="cancel-textarea"
          placeholder="Or type your own reason..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />

        {/* Actions */}
        <div className="cancel-actions">
          <button
            className="btn cancel-btn"
            onClick={handleCancel}
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm Cancellation"}
          </button>
          <button className="btn back-btn" onClick={() => navigate(-1)} disabled={loading}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}